import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  experienceEverywhere?: boolean;
}

const LeadGenerationLogo = ({experienceEverywhere = false}: Props) => (
  <span
    className={classNames(styles.leadGenerationLogo, {
      [styles.whiteText]: experienceEverywhere,
      'ml-12': experienceEverywhere,
    })}
  >
    <a href="/">Lead Generation</a>
  </span>
);

export default LeadGenerationLogo;
